
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './simp-cont-explanation';
const mainimage = '/Images/quiz1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "simpcont" },
];

const Simpcont = () => (
  <GrammarPageLayout
    level="A2"
    title="Simpcont"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Simple Continuous Exercises"
    seoDescription="Compare simple present vs. present continuous and learn when to use each tense. A2 level exercises with explanations."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default Simpcont;

